import { useGlobalContext } from '@/context/Global/GlobalContext';
import cacheKeys from '@/data/api/cacheKeys';
import { getOrderDetails } from '@/data/api/request/orderDetailsRequest';
import { getSellerOrderDetails } from '@/data/api/request/sellerOrderDetailsRequest';
import { DashboardUserType } from '@/utils/enums';
import { useQuery } from '@tanstack/react-query';

export function useGetOrderDetails(orderId: string) {
  const { session } = useGlobalContext();
  const { data, error, isLoading } = useQuery({
    queryKey: [cacheKeys.detailOrder.details, orderId],
    queryFn: () => {
      const sessionType = session?.type;
      if (sessionType === DashboardUserType.ADMIN)
        return getOrderDetails(orderId ?? '');

      if (sessionType === DashboardUserType.SELLER)
        return getSellerOrderDetails(orderId);

      throw 'error no session';
    },
    enabled: !!session && !!orderId?.trim(),
  });

  return { data, error, isLoading };
}
